import { useEffect, useState } from 'react';
import "../../css/bootstrap.min.css";
import "../../css/animate.min.css";
import "../../css/style.css";
import "../../css/responsive.css";
import "../../css/light-color.css";
import "../../css/floatlabel.css";
import "../../css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from '../../components/sections/mainwebsite/Header';
import ScrollToTop from 'react-scroll-to-top';
import { Footer } from '../../components/sections/footer';
import { AxiosInstance } from '../../components/utils';
import MainWebFooter from '../../components/sections/mainwebsite/mainwebfooter';

function AboutUs() {
  const [events, setEvents] = useState<any[]>([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await AxiosInstance.get('/api/getevent?eventstatus=OPEN,REGISTRATIONSCLOSED,REGISTRATIONSOPEN');
        if (response.data.result === 'Success') {
          setEvents(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };

    fetchEvents();
  }, []);

  return (
    <>
      <div className="antialiased light-vz circle-v ">
        <Header events={events} />
        <br></br>
        <h1 className='spacer-section'></h1>

        {/* About Us Section */}
        <section className="about-us-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                     <div className="sec-title white-heading-text">
                <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i>
                <i className="fa fa-info fa-stack-1x"></i></span></span>
                <h3 className="wow fadeInRight" data-wow-duration="500ms">About BSidesBangalore</h3>
            </div> {/* <!--sec-title end--> */}
              </div>
            </div>

            <div className="row">
              <div className="col-lg-8">
                <div className="general-text">
                  <h2>WHO WE ARE</h2>
                  <br/>
                  <p>
                    Security BSides is a community-led framework for establishing events for and by information security community members across the globe. This was launched in the United States in 2009. As of now, there have been 810 BSides events around the world, hosted in 210 cities spanning 60 countries and growing everyday. To find out more about the Security BSides movement visit the Security BSides wiki today.
                  </p>
                  <br/>
                  <p>
                    BSides Bangalore is a non-profit entity approved by BSides. It is driven and supported by cybersecurity community members across the globe. This is our first edition.BSides Bangalore presents technical security talks, technical hands-on workshops, CTF, Pannel Discussions, CxO junction and other interesting knowledge gaining events on cutting edge security technologies, with the very latest security research, development and trends.
                  </p>
<br/>
                  <h2>TARGET AUDIENCE</h2>
                  <br/>
                  <p>
                   While each BSides event is unique, we target the industry professional looking to offset or augment their current security skill set. These are industry leaders, thought leaders, CxOs,information security professionals, cybersecurity explorers like developers, entrepreneurs and even students who wish to expand their cybersecurity knowledge. Their goal is to learn and connect with others who share the same passion.
                  </p>
                  <br/>
                  <p>
                    BSides provides a small and intimate environment for the attendees to directly engage the speaker before, during, and after their talk or presentation. Attendees are looking for more than just information; they are looking to make connections they will call upon throughout the rest of the year. BSides Bangalore welcomes individuals who is passionate about learning the cutting edge technologies, trends and developments in cybersecurity.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <MainWebFooter  />
        <ScrollToTop component={<i className="fa fa-angle-up"></i>} smooth />
      </div>
    </>
  );
}

export default AboutUs;